import { Vue, Component, Prop } from 'vue-property-decorator';
import { ROSTER_UPLOADS_CONSTANTS } from '@/utils/roster';
import { rosterAPI } from '@/providers/apis/roster/roster';
import UploadStatistics from './upload-statistics/upload-statistics';

@Component({
    name: 'roster-sync-view',
    components: {
        'upload-statistics': UploadStatistics,
    },
})

export default class RosterSyncView extends Vue {

    // ----------------------------------------------------------------------------
    // Properties

    @Prop()
    private activeRoster: any;

    @Prop()
    private dataBind: any;

    private rosterSyncData: any = [];

    private errorsList: any = [];

    @Prop({default: false})
    private showSourceId: any;

    private rosterFields: any = [
        {
            key: 'name',
            label: 'File Name',
        },
        {
            key: 'newData',
            label: 'Saved Records',
        },
        {
            key: 'errors',
            label: 'Errors',
        },
    ];

    private errorsFields: any = [
        {
            label: 'Id',
            key: 'name',
        },
        {
            label: 'Error Fields',
            key: 'error',
        },
    ];


    private isShowError: boolean = false;

    private successList: any = {};

    private activeType: any = {};

    private get rosterList() {
        return this.successList[this.activeType.recordKey];
    }

    // -------------------------------------------------------------------------
    // Hooks

    private mounted() {
        this.rosterSyncData = this.parseErrors();
    }

    // -------------------------------------------------------------------------------
    // Actions

    private onSelectRow(item: any, isError: boolean = false) {
        if (isError && item.errors === 0) {
            return;
        }

        if (!isError && item.newData === 0) {
            return;
        }
        this.activeType = item;
        this.isShowError = true;
        this.errorsList = [];
        const activeRoster = this.activeRoster;
        activeRoster.showError = isError;
        activeRoster.activeType = this.activeType;
        this.$emit('displayFilterButton', this.isShowError);
    }

    private onClose() {
        this.isShowError = false;
        this.$emit('onCloseComponent');
    }


    // -----------------------------------------------------------------------------
    // Methods

    private parseErrors() {
        const activeRoster = this.activeRoster;
        const statistics: any = [];
        ROSTER_UPLOADS_CONSTANTS.forEach((type) => {
            const totalCounts = activeRoster.totalCounts[type.recordKey];
            const statistic = {
                name: type.name,
                errors: (totalCounts) ? (totalCounts.errorCount) ? totalCounts.errorCount :
                    (totalCounts.error_count) ? totalCounts.error_count : 0 : 0,
                newData: (totalCounts) ? totalCounts.syncCount ? totalCounts.syncCount :
                    totalCounts.sync_count ? totalCounts.sync_count : 0 : 0,
                errorKey: type.errorKey,
                recoredKey: type.recordKey,
            };
            statistics.push(statistic);
        });
        return statistics;
    }
}
